import styled from 'styled-components';
import { GridList, List, ListItem, Modal, ComboBox, FlexGrid } from '@sumtotal/react-foundation';

/* DashboardTemplates Styles */
export const HeaderSection = styled.div`
  margin-top: -1rem;
  padding-left: 1rem;
  padding-top: 2rem;
  padding-bottom: 0.55rem;
  -webkit-box-shadow: 0rem 0.75rem 0.375rem -0.1rem rgba(84, 84, 84, 0.07);
  -moz-box-shadow: 0rem 0.75rem 0.375rem -0.1rem rgba(84, 84, 84, 0.07);
  box-shadow: 0rem 0.75rem 0.375rem -0.1rem rgba(84, 84, 84, 0.07);
`;

export const StyledGridList = styled(GridList)`
  display: flex;
  flex-wrap: wrap;
  margin: 0rem;
  padding-left: 3rem;
`;

/* DashboardTemplateCard Styles */

export const Img = styled.img`
  height: 16.938rem;
  width: 23.813rem;
`;

export const CardContainer = styled(ListItem)`
  margin-left: 1rem;
  width: 23.813rem;
  display: block;
  padding-top: 1rem;
`;

export const InfoContainer = styled.div`
  width: 23.813rem;
  height: 11.938rem;
  padding-left: 1rem;
`;

export const ClickableCard = styled.div`
  height: 30rem;
  padding-top: 1rem;
`;

export const TemplateHeader = styled.div`
  padding-left: 0.6rem;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.362rem;
`;

export const StyledList = styled(List)`
  padding-top: 0.5rem;
  margin-left: -0.5rem;
`;

export const WidgetItem = styled.span`
  padding-left: 0.3rem;
`;

/* AddDashboardModal Styles */
export const StyledModal = styled(Modal)`
  & .MuiDialog-paper {
    height: auto;
    max-height: 35rem;
    width: 43.5rem;
  }
`;

export const DropDownField = styled(ComboBox)`
  width: 100%;
`;

export const Description = styled.span`
  font-size: 0.875rem;
`;

export const ErrorMsg = styled.span`
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1rem;
`;

export const ErrorMsgFlexGrid = styled(FlexGrid)`
  padding-top: 0rem !important;
  padding-bottom: 0rem !important;
  margin-top: 0rem;
`;
